module.exports = __webpack_public_path__ + "static/media/corporate.98480d20.PNG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/corporate.PNG
// module id = 1791
// module chunks = 1